import { render, staticRenderFns } from "./TagLotsButton.vue?vue&type=template&id=3667f719&scoped=true"
import script from "./TagLotsButton.vue?vue&type=script&lang=js"
export * from "./TagLotsButton.vue?vue&type=script&lang=js"
import style0 from "./TagLotsButton.vue?vue&type=style&index=0&id=3667f719&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3667f719",
  null
  
)

export default component.exports